import { Link } from 'react-router'
import cx from 'classnames'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'
import { Input, Button, Table } from '@driftt/tide-core-legacy'

import IconSVG from 'svg-inline-react'
import pencilIconSrc from '!svg-inline!images/svg/pencil.svg'

import StatusAvatar from 'components/shared/AgentStatusAvatar'
import EditTeamModal from 'components/settings/team/EditTeamModal'
import DeleteConfirmModal from 'components/settings/DeleteConfirmModal'

import { TEAM_NAME_EDIT_MODE } from 'app/modules/teams/constants'

import TeamHoursManager from '../TeamHoursManager'
import TeamAutoOfflineManager from '../TeamAutoOfflineManager'

import './style.styl'

const TeamNameInput = ({ name, onChange, onSave, onCancel, pending }) => {
  return (
    <div className="team-settings-name-edit-controls">
      <Input type="text" className="team-settings-name-input" value={name} onChange={onChange} />
      <Button
        type="primary"
        className="team-settings-name-save"
        onClick={onSave}
        disabled={pending || name.length === 0}
      >
        {pending ? 'Saving...' : 'Save'}
      </Button>
      <Button type="secondary" className="team-settings-name-cancel" onClick={onCancel} disabled={pending}>
        Cancel
      </Button>
    </div>
  )
}

const FormatRowsForTeamMembers = members => {
  return members.map(member => ({
    data: [
      {
        content: (
          <div className="team-member-row-content">
            <StatusAvatar user={member} />
            <div className="team-member-row-details">
              <div className="team-member-display-name">{getDisplayName(member)}</div>
              <div className="team-member-email">{member.email}</div>
            </div>
          </div>
        ),
      },
    ],
  }))
}

const TeamSettings = ({
  team,
  teamName,
  handleNameInputChange,
  teamMembers,
  activeCount,
  awayCount,
  isEditModalVisible,
  showEditModal,
  hideEditModal,
  showDeleteModal,
  hideDeleteModal,
  onConfirmDelete,
  isDeleteModalVisible,
  isDeleting,
  patchTeamPending,
  settingsUpdatePending,
  handleNameInputSave,
  handleNameInputCancel,
  handleEditTeamName,
  teamNameEditMode,
}) => (
  <div className="team-settings-container">
    <Link className="team-settings-back" to="/settings/teams">
      &lt; Teams
    </Link>
    <div className="team-settings-team-name-wrapper">
      {teamNameEditMode === TEAM_NAME_EDIT_MODE.REVIEW && (
        <div className="team-settings-name-view-controls">
          <div className={cx('team-settings-team-name', { pending: patchTeamPending })}>
            {team.name}
            <Link
              disabled={patchTeamPending}
              onClick={handleEditTeamName}
              className="team-settings-name-edit-link"
            >
              <IconSVG className="action-tool-icon action-edit-icon" src={pencilIconSrc} />
              Edit name
            </Link>
          </div>
        </div>
      )}
      {teamNameEditMode === TEAM_NAME_EDIT_MODE.EDIT && (
        <TeamNameInput
          name={teamName}
          onChange={handleNameInputChange}
          onSave={handleNameInputSave}
          onCancel={handleNameInputCancel}
          pending={patchTeamPending}
        />
      )}
    </div>
    <TeamHoursManager team={team} />
    <TeamAutoOfflineManager team={team} activeCount={activeCount} />
    <div className="team-members-list">
      <div className="team-members-list-info">
        <div className="team-members-status">
          <span className="team-members-label">Teammates</span>{' '}
          <span className="team-members-status">
            {activeCount} available / {awayCount} away
          </span>
        </div>
        <Button
          type="secondary"
          className="team-members-edit-button"
          onClick={showEditModal}
          disabled={settingsUpdatePending}
        >
          Manage team
        </Button>
      </div>
      <Table
        className="team-members-list-table"
        columns={[{ sortable: true, label: 'Teammates' }]}
        data={FormatRowsForTeamMembers(teamMembers)}
      />
    </div>
    <Button type="danger" onClick={showDeleteModal} disabled={settingsUpdatePending} className="team-delete-button">
      Delete team
    </Button>
    {isEditModalVisible && <EditTeamModal onCancelTeamEdit={hideEditModal} teamId={team.id} />}
    {isDeleteModalVisible && (
      <DeleteConfirmModal
        title={`Delete Team`}
        onClose={hideDeleteModal}
        onConfirm={onConfirmDelete}
        confirmLabel={isDeleting ? 'Deleting...' : 'Delete'}
        disableButtons={isDeleting}
      >
        <p>
          Are you sure you want to delete <strong>{team.name}</strong>?
        </p>
        <p>Any playbooks routing to this team will revert to routing to the individuals on the team</p>
      </DeleteConfirmModal>
    )}
  </div>
)

export default TeamSettings



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/Team/component.js